import { IonCol, IonContent, IonGrid, IonIcon, IonModal, IonRow } from '@ionic/react';
import React from 'react';
import PropTypes from 'prop-types';
import { ShareSocial } from 'react-share-social';
import { closeCircleSharp } from 'ionicons/icons';

import './ShareModal.scss';

const propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  shareLink: PropTypes.string.isRequired,
};

function ShareModal({ open, setOpen, shareLink }) {
  return (
    // eslint-disable-next-line react/jsx-filename-extension
    <IonModal
      isOpen={!!open}
      onDidDismiss={() => setOpen(null)}
      style={{ paddingTop: '100px', borderRadius: '8px' }}
      className="modal-wrapper"
    >
      <IonContent>
        <IonGrid style={{ width: '100%', padding: '16px' }}>
          <IonRow>
            <IonCol
              size="11"
              style={{
                fontSize: '21px',
                lineHeight: '23px',
                letterSpacing: '0.2px',
                fontFamily: 'HelveticaRegular',
                fontWeight: '600',
                marginTop: '16px',
                padding: '0px',
              }}
            >
              Share
            </IonCol>
            <IonCol size="1" style={{ display: 'flex', justifyContent: 'end' }}>
              <IonIcon
                style={{ fontSize: '24px', cursor: 'pointer' }}
                src={closeCircleSharp}
                onClick={(() => {
                  setOpen(false);
                })}
              />
            </IonCol>
          </IonRow>
          <IonRow style={{
            marginTop: '8px',
          }}
          >
            <div style={{
              fontFamily: 'AgrandirRegular',
              fontSize: '18px',
              lineHeight: '30px',
              letterSpacing: '0.75px',
              color: '#1F1F1F',
              width: '100%',
            }}
            >
              <div className="share-wrapper">
                <ShareSocial
                  url={shareLink}
                  socialTypes={['facebook', 'twitter', 'linkedin', 'line']}
                  onSocialButtonClicked={() => { setOpen(false); }}
                />
              </div>
            </div>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonModal>
  );
}

ShareModal.propTypes = propTypes;

export default ShareModal;
